import { createSlice } from "@reduxjs/toolkit";
import { ActionType, getListAction } from "./actions";
import { AdminOperationLogJson } from "../../../../domain/admin_operation_log/AdminOperationLog";

export type AdminOperationLogState = Readonly<{
    logList: AdminOperationLogJson[],
    processing: number
}>;

const adminOperationLogInitialState: AdminOperationLogState = {
    logList: [],
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: adminOperationLogInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getListAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getListAction.fulfilled,
                (state, action) => {
                    const { logList } = action.payload;
                    state.logList = logList;
                    state.processing -= 1;
                }
            )
            .addCase(
                getListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const adminOperationLogReducer = slice.reducer;
